<template>
  <div class="main-page-view-list">
    <el-row :gutter="20">
      <el-col :span="24">
        <div class="essay-title">
          <div class="essay-title-info">{{ item.title }}</div>
        </div>
        <div class="essay-time">
          <div class="essay-time-info">发布时间:{{ item.viewTime }}</div>
        </div>
        <div class="essay-info">
          <div class="essay-info-div">{{ item.info }}</div>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="1"></el-col>
      <el-col :span="23">
        <img v-if="item.img" class="essay-img" :src="item.img">
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "essayBlock",
  data() {
    return {}
  },
  props: ['item'],
  created() {

  },
}
</script>

<style scoped>
.main-page-view-list {
  margin-top: 15px;
  background-color: #fff;
  border-radius: 5px;
  min-height: 100px;
  width: 100%;
}

.essay-title {
  font-size: 20px;
  border-radius: 5px;
  height: 40px;
  line-height: 40px;
}

.main-page-view-list:hover {
  cursor: pointer;
  color: #42b8f1;
}

.essay-info {
  width: 100%;
  height: 35px;
  font-size: 15px;
  margin-top: 10px;
  line-height: 15px;
}

.essay-info-div {
  margin-left: 15px;
  font-family: 华文仿宋;
}

.essay-title-info {
  margin-top: 10px;
  margin-left: 15px;
  font-size: 18px;
  font-weight: bold;
  color: #42b983;
  overflow: hidden;
  white-space: normal;
  text-overflow: ellipsis;
  line-height: 20px;
}

.essay-img {
  margin-top: 10px;
  margin-bottom: 5px;
  margin-left: 15px;
  width: 300px;
  height: 200px;
  object-fit: contain;
}

.essay-time {
  margin-top: 10px;
  font-size: 12px;
  height: 14px;
  line-height: 14px;
}

.essay-time-info {
  margin-left: 15px;
  font-size: 14px;
  font-family: 方正舒体;
}

.icon-par-div {
  height: 40px;
}

.icon-par-essay {
  width: 25px;
  height: 25px;
  margin-top: 7px;
  margin-left: 20px;
}
</style>